import React from 'react'
import PaginationCustom from './PaginationCustom'

function TableHeader({
    title,
    startIndex,
    itemsPerPage,
    totalRecordCount,
    setItemsPerPage,
    setCurrentPage,
    totalPages,
    currentPage
}) {

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (newItemsPerPage) => {
        setItemsPerPage(newItemsPerPage);
        setCurrentPage(1);
      };

    return (
        <div className="px-6 sticky top-0 left-0 w-full py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-3 sm:space-y-0">
                <div className="flex items-center space-x-4">
                    <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
                    <div className="flex items-center space-x-2 text-sm text-gray-600">
                        <span>
                            {startIndex + 1}-{itemsPerPage} / {totalRecordCount} nəticə
                        </span>
                    </div>
                </div>

                <div className="flex items-center space-x-3">
                    <div className="flex items-center space-x-2">
                        <label className="text-sm text-gray-600">Səhifədə:</label>
                        <select
                            value={itemsPerPage}
                            onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                            className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </select>
                    </div>

                    <PaginationCustom
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                        totalPages={totalPages}
                    />
                </div>
            </div>
        </div>
    )
}

export default TableHeader